app.directive('wyswig', function($timeout, $mdDialog){
  return {
    scope: {
      ngModel: '='
    },
    restrict: 'E',
    templateUrl: "/assets/js/angular/components/directives/wyswig/wyswig.html",
    link: function(scope, element, attr){
      scope.buttonState = {
        bold: false,
        italic: false,
        underline: false,
        bullet: false,
        numbered: false,
        quote: false,
        link: false
      };

      console.log(element.attr('id'));

      var editor = new Squire(element.find('article')[0], {});
      editor.addEventListener('pathChange', function(e){
        $timeout(function(){
          scope.buttonState.bold = editor.hasFormat('b');
          scope.buttonState.italic = editor.hasFormat('i');
          scope.buttonState.underline = editor.hasFormat('u');
          scope.buttonState.bullet = editor.hasFormat('ul');
          scope.buttonState.numbered = editor.hasFormat('ol');
          scope.buttonState.quote = editor.hasFormat('blockquote');
          scope.buttonState.link = editor.hasFormat('a');
          scope.ngModel = editor.getHTML();
        });
      });

      modelWatcher = scope.$watch('ngModel', function () {
        // console.log('watch');        
        editor.setHTML(scope.ngModel);
      },true);

      editor.addEventListener('keyup', function(e){
        scope.ngModel = editor.getHTML();
        // console.log(scope.ngModel);
        modelWatcher();
      });

      scope.bold = function(){
        if (scope.buttonState.bold){
          editor.removeBold();
        }else{
          editor.bold();
        }
      }

      scope.italic = function(){
        if (scope.buttonState.italic){
          editor.removeItalic();
        }else{
          editor.italic();
        }
      }

      scope.underline = function(){
        if (scope.buttonState.underline){
          editor.removeUnderline();
        }else{
          editor.underline();
        }
      }

      scope.quote = function(){
        if (scope.buttonState.quote){
          editor.decreaseQuoteLevel();
        }else{
          editor.increaseQuoteLevel();
        }
      }

      scope.numbered = function(){
        if (scope.buttonState.numbered){
          editor.removeList();
        }else{
          editor.makeOrderedList();
        }
      }

      scope.bullet = function(){
        if (scope.buttonState.bullet){
          editor.removeList();
        }else{
          editor.makeUnorderedList();
        }
      }

      scope.link = function($event){
        if (scope.buttonState.link){
          editor.removeLink();
        }else{
          $mdDialog.show($mdDialog
            .prompt()
            .title('New Link')
            .textContent('What is the URL of the link?')
            .ok('ok')
            .cancel('cancel')
            .targetEvent($event)
          ).then(function(result) {
             if (result && result !== ''){
               editor.makeLink(result);
             }
          });
        }
      }

    }
  }
});
